import EditWidget from '@sfly/edit-widget';
import '@sfly/edit-widget/style.css';

// @ts-ignore
window.EditWidget = EditWidget;
export default EditWidget;
